/*!
 * Cover Dog - cart display. Shows the customer's own cover (the "_Cover Proof" photo saved with the
 * line item) instead of the stock calendar image in the cart page and the cart drawer, and tidies
 * the photo lines the drawer prints under the item name.
 */
(function () {
  'use strict';
  if (window.__coverDogCart) return;
  window.__coverDogCart = true;

  var PROOF = '_Cover Proof';
  var running = false, again = false, timer = null;

  function isUrl(v) { return typeof v === 'string' && /^(https?:)?\/\//.test(v); }

  function apply() {
    if (running) { again = true; return; }
    if (!document.querySelector('.ajaxcart__row')) return;
    running = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        (cart.items || []).forEach(function (item, i) {
          var props = item.properties || {};
          var proof = props[PROOF];
          var rows = document.querySelectorAll('.ajaxcart__row[data-line="' + (i + 1) + '"]');
          Array.prototype.forEach.call(rows, function (row) {
            if (isUrl(proof)) {
              var img = row.querySelector('.cart-table__image img');
              if (img && img.getAttribute('src') !== proof) {
                img.removeAttribute('srcset');
                img.removeAttribute('data-srcset');
                img.setAttribute('data-src', proof);
                img.setAttribute('src', proof);
                img.alt = 'Your custom cover';
                img.classList.add('cdog-cart-img');
              }
            }
            // The drawer prints every property as "key: value". Hide internal (_) ones and show
            // uploaded photos as a short "added" note instead of a long file link.
            Array.prototype.forEach.call(row.querySelectorAll('.cart-table__details small'), function (el) {
              var text = el.textContent || '';
              var key = text.split(':')[0].trim();
              if (key.charAt(0) === '_') { el.style.display = 'none'; return; }
              if (/ Photo$/.test(key) && isUrl(props[key]) && !el.getAttribute('data-cdog')) {
                el.setAttribute('data-cdog', '1');
                el.textContent = key + ': ✓ added';
              }
            });
          });
        });
      })
      .catch(function () { /* cart display is cosmetic; never block the cart */ })
      .then(function () {
        running = false;
        if (again) { again = false; schedule(); }
      });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(apply, 120); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();

  // The drawer is re-rendered every time the cart changes.
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n.nodeType === 1 && (n.closest('.CartContainer') || n.closest('.cart-table')) && muts[i].addedNodes.length) {
          schedule();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
